/** SEO config for static informational pages (hy / ru / en) */

export const DEFAULT_OG_IMAGE = "https://vlv.am/public/logos/vlv_open_graph.png";

const t = (hy, ru, en) => ({ hy, ru, en });

export const STATIC_PAGES_SEO = {
  home: {
    path: "/",
    schemaType: "WebPage",
    title: t(
      "VLV Centre — կահույք, էլեկտրատեխնիկա և էլեկտրոնիկա",
      "VLV Centre — мебель, бытовая техника и электроника",
      "VLV Centre — furniture, appliances and electronics"
    ),
    description: t(
      "VLV.am | Կահույք, էլեկտրատեխնիկա, սմարթֆոններ, համակարգիչներ և ավելին։ Մշտապես գործող ակցիաներ, երաշխավորված որակ և շահավետ գնառաջարկներ։",
      "VLV.am | Мебель, бытовая техника, смартфоны, компьютеры и многое другое. Акции, гарантия качества и выгодные цены.",
      "VLV.am | Furniture, appliances, smartphones, computers and more. Ongoing promotions, quality guarantee and great prices."
    ),
  },
  about: {
    path: "/about-us",
    schemaType: "AboutPage",
    title: t(
      "Մեր մասին | VLV Centre — Ամեն ինչ մեկ վայրից",
      "О нас | VLV Centre — всё в одном месте",
      "About us | VLV Centre — everything in one place"
    ),
    description: t(
      "«ՎիԷլՎի Սենթր»՝ 2004 թվականից։ 22+ տարի շուկայում, 10․000+ ապրանք և 150+ բրենդ։ Կենցաղային տեխնիկա, կահույք և սանտեխնիկա մեկ վայրից։",
      "VLV Centre — с 2004 года. Более 22 лет на рынке, 10 000+ товаров и 150+ брендов. Бытовая техника, мебель и сантехника в одном месте.",
      "VLV Centre since 2004. 22+ years on the market, 10,000+ products and 150+ brands. Home appliances, furniture and sanitary ware in one place."
    ),
  },
  delivery: {
    path: "/delivery",
    schemaType: "WebPage",
    title: t("Առաքում | VLV Centre", "Доставка | VLV Centre", "Delivery | VLV Centre"),
    description: t(
      "VLV Centre առաքման պայմանները Երևանում և Հայաստանի մարզերում։",
      "Условия доставки VLV Centre в Ереване и регионах Армении.",
      "VLV Centre delivery terms in Yerevan and across Armenia."
    ),
  },
  credit: {
    path: "/credit",
    schemaType: "WebPage",
    title: t("Ապառիկ | VLV Centre", "Кредит | VLV Centre", "Credit | VLV Centre"),
    description: t(
      "Ապառիկ գնումներ VLV Centre-ում՝ հարմար պայմաններ և բանկային առաջարկներ։",
      "Покупка в кредит в VLV Centre — удобные условия и банковские предложения.",
      "Buy on credit at VLV Centre — flexible terms and bank offers."
    ),
  },
  contacts: {
    path: "/contacts",
    schemaType: "ContactPage",
    title: t("Կապ | VLV Centre", "Контакты | VLV Centre", "Contacts | VLV Centre"),
    description: t(
      "VLV Centre խանութների հասցեներ, հեռախոսահամարներ և աշխատանքային ժամեր։",
      "Адреса магазинов VLV Centre, телефоны и часы работы.",
      "VLV Centre store addresses, phone numbers and working hours."
    ),
  },
  payment: {
    path: "/payment",
    schemaType: "WebPage",
    title: t("Վճարում | VLV Centre", "Оплата | VLV Centre", "Payment | VLV Centre"),
    description: t(
      "VLV Centre վճարման եղանակներ՝ կանխիկ, քարտ, առցանց և այլ տարբերակներ։",
      "Способы оплаты в VLV Centre: наличные, карта, онлайн и другие варианты.",
      "Payment methods at VLV Centre: cash, card, online and more."
    ),
  },
  privacy: {
    path: "/privacy",
    schemaType: "WebPage",
    title: t(
      "Գաղտնիության քաղաքականություն | VLV Centre",
      "Политика конфиденциальности | VLV Centre",
      "Privacy Policy | VLV Centre"
    ),
    description: t(
      "VLV Centre գաղտնիության քաղաքականություն և անձնական տվյալների պաշտպանություն։",
      "Политика конфиденциальности VLV Centre и защита персональных данных.",
      "VLV Centre privacy policy and personal data protection."
    ),
  },
  service: {
    path: "/service",
    schemaType: "WebPage",
    title: t("Սպասարկում | VLV Centre", "Обслуживание | VLV Centre", "Service | VLV Centre"),
    description: t(
      "VLV Centre սպասարկում, տեղադրում և հետվաճառքային ծառայություններ։",
      "Сервис VLV Centre: обслуживание, установка и послепродажная поддержка.",
      "VLV Centre service, installation and after-sales support."
    ),
  },
  faq: {
    path: "/faq",
    schemaType: "FAQPage",
    title: t(
      "Հաճախ տրվող հարցեր | VLV Centre",
      "Часто задаваемые вопросы | VLV Centre",
      "FAQ | VLV Centre"
    ),
    description: t(
      "Պատասխաններ VLV Centre-ի հաճախ տրվող հարցերին՝ պատվեր, առաքում, ապառիկ և այլն։",
      "Ответы на частые вопросы о VLV Centre: заказ, доставка, кредит и другое.",
      "Answers to frequent questions about VLV Centre: orders, delivery, credit and more."
    ),
  },
  job: {
    path: "/job",
    schemaType: "WebPage",
    title: t("Աշխատատեղեր | VLV Centre", "Вакансии | VLV Centre", "Jobs | VLV Centre"),
    description: t(
      "Բաց աշխատատեղեր VLV Centre-ում։ Միացեք մեր թիմին։",
      "Открытые вакансии в VLV Centre. Присоединяйтесь к нашей команде.",
      "Open job positions at VLV Centre. Join our team."
    ),
  },
  blog: {
    path: "/blog",
    schemaType: "CollectionPage",
    title: t("Բլոգ | VLV Centre", "Блог | VLV Centre", "Blog | VLV Centre"),
    description: t(
      "VLV Centre բլոգ՝ նորություններ, խորհուրդներ և ակնարկներ տեխնիկայի ու կահույքի մասին։",
      "Блог VLV Centre: новости, советы и обзоры техники и мебели.",
      "VLV Centre blog: news, tips and reviews about appliances and furniture."
    ),
  },
  article: {
    path: "/article",
    schemaType: "CollectionPage",
    title: t("Հոդվածներ | VLV Centre", "Статьи | VLV Centre", "Articles | VLV Centre"),
    description: t(
      "VLV Centre հոդվածներ և օգտակար նյութեր գնորդների համար։",
      "Статьи VLV Centre и полезные материалы для покупателей.",
      "VLV Centre articles and helpful guides for shoppers."
    ),
  },
  reporting: {
    path: "/reporting",
    schemaType: "WebPage",
    title: t("Հաշվետվություն | VLV Centre", "Отчеты | VLV Centre", "Reporting | VLV Centre"),
    description: t(
      "VLV Centre հաշվետվություններ և պաշտոնական տեղեկատվություն։",
      "Отчеты и официальная информация VLV Centre.",
      "VLV Centre reports and official information."
    ),
  },
  sales: {
    path: "/sales",
    schemaType: "CollectionPage",
    title: t("Ակցիաներ | VLV Centre", "Акции | VLV Centre", "Promotions | VLV Centre"),
    description: t(
      "Ընթացիկ ակցիաներ և հատուկ առաջարկներ VLV Centre-ում։",
      "Текущие акции и специальные предложения в VLV Centre.",
      "Current promotions and special offers at VLV Centre."
    ),
  },
  "download-app": {
    path: "/download-app",
    schemaType: "WebPage",
    title: t(
      "Բեռնել հավելվածը | VLV Centre",
      "Скачать приложение | VLV Centre",
      "Download the app | VLV Centre"
    ),
    description: t(
      "Բեռնեք VLV Centre հավելվածը App Store-ից կամ Google Play-ից։",
      "Скачайте приложение VLV Centre в App Store или Google Play.",
      "Download the VLV Centre app from the App Store or Google Play."
    ),
  },
  order: {
    path: "/order",
    schemaType: "WebPage",
    title: t("Պատվեր | VLV Centre", "Заказ | VLV Centre", "Order | VLV Centre"),
    description: t(
      "Պատվիրեք ապրանք VLV Centre-ից առցանց կամ թողեք հայտ։",
      "Закажите товар в VLV Centre онлайн или оставьте заявку.",
      "Order a product from VLV Centre online or submit a request."
    ),
  },
  brandSeeAll: {
    path: "/brandSeeAll",
    schemaType: "CollectionPage",
    title: t("Արտադրողներ | VLV Centre", "Производители | VLV Centre", "Brands | VLV Centre"),
    description: t(
      "VLV Centre-ում ներկայացված բրենդների և արտադրողների ամբողջական ցանկ։",
      "Полный список брендов и производителей в VLV Centre.",
      "Full list of brands and manufacturers at VLV Centre."
    ),
  },
  ventilation: {
    path: "/ventilation-order",
    schemaType: "WebPage",
    title: t(
      "Օդափոխության համակարգեր | VLV Centre",
      "Системы вентиляции | VLV Centre",
      "Ventilation systems | VLV Centre"
    ),
    description: t(
      "Պատվիրեք օդափոխության համակարգ VLV Centre-ից։",
      "Закажите систему вентиляции в VLV Centre.",
      "Order a ventilation system from VLV Centre."
    ),
  },
  catalog: {
    path: "/catalog",
    schemaType: "CollectionPage",
    title: t("Կատալոգ | VLV Centre", "Каталог | VLV Centre", "Catalog | VLV Centre"),
    description: t(
      "VLV Centre կատալոգ՝ կահույք, էլեկտրատեխնիկա և էլեկտրոնիկա։",
      "Каталог VLV Centre: мебель, бытовая техника и электроника.",
      "VLV Centre catalog: furniture, appliances and electronics."
    ),
  },
  categories: {
    path: "/categories",
    schemaType: "CollectionPage",
    title: t("Կատեգորիաներ | VLV Centre", "Категории | VLV Centre", "Categories | VLV Centre"),
    description: t(
      "VLV Centre ապրանքների կատեգորիաներ։",
      "Категории товаров VLV Centre.",
      "VLV Centre product categories."
    ),
  },
  salesDiscount: {
    path: "/sales/discount",
    schemaType: "CollectionPage",
    title: t("Զեղչեր | VLV Centre", "Скидки | VLV Centre", "Discounts | VLV Centre"),
    description: t(
      "Զեղչված ապրանքներ VLV Centre-ում։",
      "Товары со скидкой в VLV Centre.",
      "Discounted products at VLV Centre."
    ),
  },
  groupPurchase: {
    path: "/group-purchase-of-products",
    schemaType: "CollectionPage",
    title: t(
      "Խմբային գնումներ | VLV Centre",
      "Групповые покупки | VLV Centre",
      "Group purchases | VLV Centre"
    ),
    description: t(
      "Խմբային գնումների առաջարկներ VLV Centre-ում։",
      "Предложения групповых покупок в VLV Centre.",
      "Group purchase offers at VLV Centre."
    ),
  },
  search: {
    path: "/search",
    schemaType: "SearchResultsPage",
    title: t("Որոնում | VLV Centre", "Поиск | VLV Centre", "Search | VLV Centre"),
    description: t(
      "Ապրանքների որոնում VLV Centre-ում։",
      "Поиск товаров в VLV Centre.",
      "Search products at VLV Centre."
    ),
  },
  searchNull: {
    path: "/search-null",
    schemaType: "WebPage",
    noindex: true,
    title: t(
      "Արդյունք չի գտնվել | VLV Centre",
      "Ничего не найдено | VLV Centre",
      "No results | VLV Centre"
    ),
    description: t(
      "Որոնման արդյունք չի գտնվել։ Դիտեք առաջարկվող կատեգորիաները VLV Centre-ում։",
      "По вашему запросу ничего не найдено. Смотрите рекомендуемые категории VLV Centre.",
      "No results found. Browse recommended categories at VLV Centre."
    ),
  },
  compare: {
    path: "/compare",
    schemaType: "WebPage",
    noindex: true,
    title: t("Համեմատում | VLV Centre", "Сравнение | VLV Centre", "Compare | VLV Centre"),
    description: t(
      "Ապրանքների համեմատում VLV Centre-ում։",
      "Сравнение товаров в VLV Centre.",
      "Compare products at VLV Centre."
    ),
  },
  favorite: {
    path: "/favorite",
    schemaType: "WebPage",
    noindex: true,
    title: t("Նախընտրելիներ | VLV Centre", "Избранное | VLV Centre", "Favorites | VLV Centre"),
    description: t(
      "Ձեր նախընտրելի ապրանքները VLV Centre-ում։",
      "Ваши избранные товары в VLV Centre.",
      "Your favorite products at VLV Centre."
    ),
  },
  cart: {
    path: "/cart",
    schemaType: "WebPage",
    noindex: true,
    title: t("Զամբյուղ | VLV Centre", "Корзина | VLV Centre", "Cart | VLV Centre"),
    description: t(
      "Ձեր զամբյուղը VLV Centre-ում։",
      "Ваша корзина в VLV Centre.",
      "Your cart at VLV Centre."
    ),
  },
  profileDashboard: {
    path: "/profile/dashboard",
    schemaType: "WebPage",
    noindex: true,
    title: t("Անձնական էջ | VLV Centre", "Личный кабинет | VLV Centre", "Account | VLV Centre"),
    description: t(
      "VLV Centre անձնական էջ։",
      "Личный кабинет VLV Centre.",
      "VLV Centre account page."
    ),
  },
  profilePersonalInfo: {
    path: "/profile/personal-info",
    schemaType: "WebPage",
    noindex: true,
    title: t(
      "Անձնական տվյալներ | VLV Centre",
      "Личные данные | VLV Centre",
      "Personal info | VLV Centre"
    ),
    description: t(
      "Անձնական տվյալների կառավարում VLV Centre-ում։",
      "Управление личными данными в VLV Centre.",
      "Manage personal information at VLV Centre."
    ),
  },
  profileAddresses: {
    path: "/profile/my-addresses",
    schemaType: "WebPage",
    noindex: true,
    title: t("Հասցեներ | VLV Centre", "Адреса | VLV Centre", "Addresses | VLV Centre"),
    description: t(
      "Առաքման հասցեներ VLV Centre-ում։",
      "Адреса доставки в VLV Centre.",
      "Delivery addresses at VLV Centre."
    ),
  },
  profileOrders: {
    path: "/profile/order-history",
    schemaType: "WebPage",
    noindex: true,
    title: t(
      "Պատվերների պատմություն | VLV Centre",
      "История заказов | VLV Centre",
      "Order history | VLV Centre"
    ),
    description: t(
      "Ձեր պատվերների պատմությունը VLV Centre-ում։",
      "История ваших заказов в VLV Centre.",
      "Your order history at VLV Centre."
    ),
  },
  profileVirtual: {
    path: "/profile/virtual-products",
    schemaType: "WebPage",
    noindex: true,
    title: t(
      "Վիրտուալ ապրանքներ | VLV Centre",
      "Виртуальные товары | VLV Centre",
      "Virtual products | VLV Centre"
    ),
    description: t(
      "Վիրտուալ ապրանքներ VLV Centre-ում։",
      "Виртуальные товары в VLV Centre.",
      "Virtual products at VLV Centre."
    ),
  },
  profileWishlist: {
    path: "/profile/my-wishlist",
    schemaType: "WebPage",
    noindex: true,
    title: t(
      "Ցանկությունների ցանկ | VLV Centre",
      "Список желаний | VLV Centre",
      "Wishlist | VLV Centre"
    ),
    description: t(
      "Ձեր ցանկությունների ցանկը VLV Centre-ում։",
      "Ваш список желаний в VLV Centre.",
      "Your wishlist at VLV Centre."
    ),
  },
};

export function getStaticPageSeo(pageKey, lang = "hy") {
  const page = STATIC_PAGES_SEO[pageKey];
  if (!page) return null;
  const language = ["hy", "ru", "en"].includes(lang) ? lang : "hy";
  return {
    pageKey,
    path: page.path,
    schemaType: page.schemaType || "WebPage",
    title: page.title[language] || page.title.hy,
    description: page.description[language] || page.description.hy,
    ogImage: page.ogImage || DEFAULT_OG_IMAGE,
    noindex: Boolean(page.noindex),
  };
}
